export default __webpack_public_path__ + "static/media/income.d58effe2.svg";